import {destroyCookie} from 'nookies'
import {firebaseAuth, firestore} from 'services/firebase-packages'
import {generateId} from 'plugins/generate-id'
import {electron} from 'services/electron'
import {db, auth} from 'services/firebase'
import {getIdToken} from './helpers'
import {notEmpty} from 'plugins/array-fns'

export const startAuthProcess = () => {
  const clientToken = generateId()

  const clientTokensRef = firestore.collection(db, 'client-tokens')
  const clientTokenDoc = firestore.doc(clientTokensRef, clientToken)

  const unsubscribe = firestore.onSnapshot(clientTokenDoc, async (snapshot) => {
    if (!snapshot?.exists()) return

    const accessToken: string = snapshot.data()?.access_token

    if (accessToken) {
      await firebaseAuth.signInWithCustomToken(auth, accessToken)
      unsubscribe()
      electron?.showWindow()
    }
  })

  return clientToken
}

export const createAccessToken = async (clientToken: string) => {
  const idToken = await getIdToken()

  return fetch('/api/auth/client-token', {
    method: 'POST',
    headers: {
      Authorization: `Firebase ${idToken}`,
      'Content-Type': 'application/json; charset=utf-8',
    },
    body: JSON.stringify({
      client_token: clientToken,
      id_token: idToken,
    }),
  })
}

const listAllIndexedDatabases = async (): Promise<string[]> => {
  if (
    typeof window.indexedDB != 'undefined' &&
    typeof indexedDB.databases === 'function'
  ) {
    const databases = await indexedDB.databases()

    return databases.map((db) => db.name).filter(notEmpty)
  } else {
    return []
  }
}

const deleteAllIndexedDatabases = async () => {
  const databases = await listAllIndexedDatabases()

  await Promise.all(databases.map((db) => indexedDB.deleteDatabase(db)))
}

export const signOut = async ({resetDatabases = true} = {}) => {
  await auth.signOut()

  destroyCookie(null, 'indexApp')

  if (resetDatabases) {
    await deleteAllIndexedDatabases()
    localStorage.clear()
  }
}
